import Vue from 'vue'
import { importSPKI, jwtVerify } from 'jose'
import oddOneOutContent from '@/assets/odd_one_out.json'

let isSubscriber = true
const TOPIC_ALIASES = {
  'house-furniture': 'house-and-furniture',
}

const normalizeTopicKey = (key) => TOPIC_ALIASES[key] || key

const extractTopicKey = (contentKey) => {
  if (!contentKey) {
    return undefined
  }
  if (!contentKey.includes('__')) {
    return contentKey
  }
  const [gameKey, topicKey] = contentKey.split('__')
  if (gameKey !== 'odd_one_out') {
    return undefined
  }
  return topicKey
}

const publicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAyguyWZwCnnx1Vl1Np4iw
Cp8j3BgCpb1dGShBVKQXWcgNS0qx4zl2LplWXDm+Hjc8HFjzcPBm2o9XAQt/k4rv
bfFv6yMrCrDCt8F0x38fbLbDPw7WgmSUq4gi0DKWxj55Wt00JFfaquBNahlEydFX
/Tw051fJ/rSH451B/Ji4cAIjs52DyslfmVFwPaQeFUR3vpA+pUvpAkhjaNZ3Tvhl
m3dI5JPAX7ajDXIy7mmUFzrNXTBF1FSBNK3JJ9++J3j6JaXGIO3k5ktdFshJN+4k
gIiI2wuk5SN9cnrTg3UKnFKTm4KsH9wwCIcTytYmPu38tjHI6GgsB4uTzFXLiWEu
6QIDAQAB
-----END PUBLIC KEY-----
`

async function isAuthorised() {
  if (Vue.config.devtools) {
    return true
  }

  const urlParams = new URLSearchParams(window.location.search)
  const token = urlParams.get('token')

  const algorithm = 'RS256'
  const ecPublicKey = await importSPKI(publicKey, algorithm)
  const vals = await jwtVerify(token, ecPublicKey)

  isSubscriber = vals.payload.subscribed
  return vals
}

function canAccessContent(topicKey) {
  if (isSubscriber) {
    return true
  }

  const normalizedKey = normalizeTopicKey(extractTopicKey(topicKey))
  if (!normalizedKey) {
    return false
  }

  const freeTopics = oddOneOutContent?.settings?.freeTopics || []
  return freeTopics.includes(normalizedKey)
}

export { isAuthorised, canAccessContent, isSubscriber }
